import type { HTMLAttributes, ReactNode } from 'react'
import { forwardRef } from 'react'

import type { Interpolation, Theme } from '@emotion/react'
import { useTheme } from '@emotion/react'

import * as styles from './paper.styles'

type Props = {
  css?: Interpolation<Theme>
  children: ReactNode
  noMargin?: boolean
  noPadding?: boolean
  as?: 'div' | 'article'
} & HTMLAttributes<HTMLDivElement>

export const Paper = forwardRef<HTMLDivElement, Props>(
  (
    { children, noMargin = false, noPadding = false, as = 'div', css: customCss, ...other },
    ref
  ) => {
    const theme = useTheme()
    const Component = as
    const paperClassName = [
      styles.root(theme),
      !noMargin && styles.margin(theme),
      !noPadding && styles.padding(theme),
      !!other.onClick && styles.clickable(theme),
    ]

    return (
      <Component ref={ref} css={[paperClassName, customCss]} data-testid="paper" {...other}>
        {children}
      </Component>
    )
  }
)

Paper.displayName = 'Paper'
